
<template>
  <div>
    <div id = "testid" class="sdf">
      <h2>Wybierz kategorie problemu:</h2>
      <div v-for="(category, index) in docs" @click="showAnswers($event, index)" :class="{category: 1, catActive: catTab[index], vtp: category.category.includes('VTP')}"  :key="category.category" :id="'cat' + index">
        <div class = "catContainer">
          <span id= "close" v-if="catTab[index]" :class="materialsymbolsoutlined" @click="hideAnswers($event, index)">close</span>
          <h3>{{category.category}}</h3>
        </div>
        <transition-group tag = "div" name ="fadeGroup">
          <div v-for="(answer, jindex) in category.answers" :key="jindex" v-if="catTab[index]" class="answersContainer">
              <p v-if="(jindex == 0)" v-html = "category.intro"></p>
              <span id= "closeanswer" v-if="showDetailsTable[index][jindex]" :class="materialsymbolsoutlined" @click="handleAnswerClose(index, jindex, $event)">close</span>
              <div class ="answer" :id ="answer.search(/\n/)" v-html="showDetailsTable[index][jindex] ? answer : answer.substring(0, answer.search(/\n/))" @click="handleAnswerClick(index, jindex, $event)"></div>
          </div>
        </transition-group>
      </div>
      <!-- Zając się teraz tym X na małych rozdzielczościach -->
      
    </div>
    <h4 class="error">{{errorMessage}}</h4>
  </div>
</template>
  
<script>
//showDetailsTable[index][jindex] ? answer : answer.substring(0, 45) + '...'
  // @ is an alias to /src

  import { computed } from '@vue/reactivity';
import { onMounted, onUpdated, ref, watchEffect } from 'vue';
  import getDataFirebase from '../composables/getDataFirebase'
  
  export default {
    name: 'Sdf',
    props: ['id'],
    setup(props){
      const materialsymbolsoutlined = 'material-symbols-outlined close closeAnswer'
      const answersTab = ref([
        
      ])
      const showA = ref(false)
      const detailedAnswer = ref([{
        category: []
      }])

      onMounted(()=>{
        document.querySelector('body').style.overflow = 'scroll'
        document.querySelectorAll('a').forEach(a => {
          console.log(a)
        })
      })
      onUpdated(() => {
        const answers = document.querySelectorAll('.answer')
        answers.forEach((answer) => {
          if(answer.hasAttribute('showdetails')){

          }
        })
      })
      const show = ref(true)
      const { categories: docs, openEditsTable: catTab, errorMessage, load: loadFirestore, showDetailsTable } = getDataFirebase()
      watchEffect(()=>{
        loadFirestore(props.id)
      })
      const showAnswers = (event, index) => {
        if(event.target.innerHTML === 'close'){

        }
        else{
          catTab.value[index] = true
        }
      }
      const hideAnswers = (event, index) => {
        catTab.value[index] = false
      }
      const handleAnswerClose = (index, jindex, event)=>{
        showDetailsTable.value[index][jindex] = false
        event.target.nextElementSibling.classList.toggle('answer');

        
      }
      const handleAnswerClick = (index, jindex, event) =>{
        if(!showDetailsTable.value[index][jindex]){
          event.currentTarget.classList.toggle('answer')
          showDetailsTable.value[index][jindex] = true
        }
      }


      const preliminary = computed(() => {
        let preliminaryBuf = []
        docs.value.forEach(doc => {
          doc.answers.forEach(answer => {
            preliminaryBuf.push(answer.substring(0, 5) + '...')
          })
        })
        console.log(preliminaryBuf)
       return preliminaryBuf
      })
      return{
        errorMessage, docs, catTab, show, showAnswers, preliminary, showA, hideAnswers, answersTab, detailedAnswer, showDetailsTable,materialsymbolsoutlined, handleAnswerClick, handleAnswerClose
      }
    }
  }
  </script>
  <style>
    .category{
      background-color: lightblue;
      width: 70vw;
      margin: 1em auto;
      padding: 0.5em 1em;
      border-radius: 1em;
      transition: all 0.3s ease-in-out;
      max-height: 2.6em;
    }
    .category:hover{
      cursor: pointer;
      transform: scale(1.1);
      background-color: rgba(173, 216, 230, 0.3);
    }
    .category > h5{
      margin-top: 0.5em;
    }
    .sdf > h2{
       margin-bottom: 2em;
    }
    .sdf .catActive{
      cursor: default;
      transform: scale(1.0);
      transition: max-height 1.7s ease-in-out;
      background-color: rgba(173, 216, 230, 0.3);
      max-height: 202.2em;
    }
    .catContainer{
      text-align: right;
      position: relative;
    }
    .catContainer > h3{
      text-align: center;
      margin: 0.5em 0em;
    }
    .close{
      position: absolute;
      right: 0.2em;
      font-size:  1em;
      z-index: 3;
    }
    #close:hover{
      cursor: pointer;
      transform: scale(2);
    }
    #closeanswer{
      right: 1.2em;
    }
    .fadeGroup-enter-from, .fadeGroup-leave-to{
      opacity: 0;
    }
    .fadeGroup-enter-active{
      transition: all 0.7s ease-in-out;
    }
    .fadeGroup-leave-active{
      transition: all 0.3s ease-in-out;
    }
    /* .fadeGroup-move{
      transition: all 0.7s ease-in-out;
    } */
  </style>
  